var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuditLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6508 0.240762C23.0701 0.600184 23.1187 1.23148 22.7593 1.65081L10.7593 15.6508C10.5677 15.8743 10.2874 16.002 9.99306 16C9.69871 15.9979 9.42022 15.8663 9.23178 15.6402L4.23178 9.6402C3.87821 9.21593 3.93554 8.58536 4.35982 8.2318C4.78409 7.87823 5.41466 7.93556 5.76822 8.35983L10.0108 13.4509L21.2407 0.349227C21.6002 -0.0700991 22.2315 -0.118661 22.6508 0.240762Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.00002C0 0.447733 0.447715 1.81264e-05 1 1.81264e-05H16C16.5523 1.81264e-05 17 0.447733 17 1.00002C17 1.5523 16.5523 2.00002 16 2.00002H2V14.1C2 15.6701 2.91995 17.3757 4.50054 18.8743C6.00655 20.3023 8.00326 21.4322 10 21.9677C11.9967 21.4322 13.9935 20.3023 15.4995 18.8743C17.08 17.3757 18 15.6701 18 14.1V10.9C18 10.3477 18.4477 9.90002 19 9.90002C19.5523 9.90002 20 10.3477 20 10.9V14.1C20 16.4299 18.67 18.6243 16.8755 20.3257C15.0663 22.0412 12.6624 23.3787 10.2375 23.9714C10.0814 24.0096 9.91855 24.0096 9.76255 23.9714C7.33764 23.3787 4.93375 22.0412 3.12446 20.3257C1.33005 18.6243 0 16.4299 0 14.1V1.00002Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLogo);
export default __webpack_public_path__ + "static/media/AuditLogo.9eb8a389b3abcc9fcd230944428241ff.svg";
export { ForwardRef as ReactComponent };